if(!window.theme._registeredSections['homepage-hero-slider'] === true){
  theme.HomepageHeroSlider = (function() {

      /**
       * Constructor
       */
      function HomepageHeroSlider(container) {
    
        const sectionName = container.dataset.sectionName.replace('-', '_');
        const handleViewPromotionEvent = () => {
          const cards = container.querySelectorAll('.hero-slide');
          if (!cards.length || !window.theme.observeElement) { return; }
    
          [...cards].forEach((card, index) => {
            window.theme.observeElement(card, () => {
              const blockSettings = JSON.parse(card.dataset.blockSettings || {});
              if (!Object.keys(blockSettings)) { return; }
    
              const creativeName = blockSettings.campaign_name;
              const ecommerce = {
                creative_name: creativeName,
                creative_slot: sectionName,
                promotion_id: `${creativeName} | ${sectionName}`,
                promotion_name: blockSettings.title,
              };
              const menuNavigationAction = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
              const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
              window.pushEvent({
                event: 'view_promotion',
                menu_navigation_state: menuNavigationState,
                ecommerce,
              }, 'ecommerce');

              localStorage.setItem('ga4-promotionView', JSON.stringify(ecommerce));
    
              const links = card.querySelectorAll('a[href]');
              if (!links.length) { return; }
    
              links.forEach((link) => {
                link.addEventListener('click', () => {
                  const menuNavigationClick = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
                  const menuNavigationClickState = menuNavigationClick.menu_navigation_state || {};
                  window.pushEvent({
                    event: 'select_promotion',
                    menu_navigation_state: menuNavigationClickState,
                    ecommerce,
                  }, 'ecommerce');
                });
              });
            });
          });
        };
        handleViewPromotionEvent();
    
        this.settings = container.dataset.sectionSettings || '{}';
        this.$slider = $(container).find('.hero-slider');
        this.totalSlides = container.dataset.totalSlides ? Number(container.dataset.totalSlides) : null;
        this.hasMultilang = container.hasAttribute('data-multilang-section');
    
        if (this.totalSlides && this.totalSlides < 2) {
          return;
        }

        // Parse the settings string passed through from liquid
        var userSettings = JSON.parse(this.settings);
    
        // Create some defaults
        var defaultSettings = {
          infinite: true,
          autoplaySpeed: userSettings.slide_speed,
          arrows:userSettings.arrows || false,
          dots:userSettings.dots || true,
          draggable:userSettings.draggable || false,
          speed: 800,
          pauseOnHover: true,
          responsive: [
            {
              breakpoint: window.theme.settings.grid_medium || 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        };
    
        // Merge the objects - userSettings will have precedence
        var sliderSettings = $.extend(defaultSettings, userSettings);
        
        var initCount = 0;
        var shouldShowDots = () => {
          if (!this.$slider.hasClass('slick-initialized')) return false;
          if (this.hasMultilang && initCount === 1) return false; // Skip first init for multilang
          
          var $dots = this.$slider.find('.slick-dots');
          if (!$dots.length) return false;
          
          var slideCount = this.$slider.find('.slick-slide:not(.slick-cloned)').length;
          var dotCount = $dots.find('li').length;
          
          // Only show if more than 1 slide and counts match
          return slideCount > 1 && Math.abs(dotCount - slideCount) <= 1;
        };
        
        var hideDots = () => this.$slider.removeClass('dots-ready');
        var showDots = () => this.$slider.addClass('dots-ready');
        hideDots();
        
        // Observer to immediately hide any dots that appear
        var observer = new MutationObserver(() => {
          var $dots = this.$slider.find('.slick-dots');
          if ($dots.length) {
            hideDots();
          }
        });
        observer.observe(this.$slider[0], { childList: true, subtree: true });
        
        // Check when to show/hide dots
        var checkAndShow = () => {
          setTimeout(() => {
            if (shouldShowDots()) {
              observer.disconnect();
              showDots();
            } else {
              hideDots();
            }
          }, this.hasMultilang ? 200 : 50);
        };
        
        this.$slider.on('init reInit', () => {
          initCount++;
          checkAndShow();
        });
        
        // Hide dots before and during initialization
        var hideInterval = setInterval(() => {
          if (shouldShowDots()) {
            clearInterval(hideInterval);
            observer.disconnect();
            showDots();
          } else {
            hideDots();
          }
        }, 5);
        
        // Init slick carousel
        this.$slider.slick(sliderSettings);
        
        setTimeout(() => {
          clearInterval(hideInterval);
          if (shouldShowDots()) showDots();
        }, 2000);
        
        let sliderComponent = this.$slider;
        $(container).on('touchend', e => {
          this.$slider.slick('slickPlay');
        });
          $(container).on('click','.slick-dots li button', function(event){  
              event.stopPropagation(); // use this
              setTimeout(function(){
                  sliderComponent.slick('slickPlay');
              },300)
          });
      }
    
    
      /**
       * Event handler that updates the fade setting based on slidesToShow
       */
      HomepageHeroSlider.prototype.slideHandler = function(event) {
    
        if (event.target.name.indexOf('slidesToShow') === -1) {
          return;
        }
    
        var fade = window.top.document.querySelector('[id$=fade]');
    
        if (event.target.value > 1) {
          fade.checked = false;
          fade.disabled = true;
        } else {
          fade.checked = true;
          fade.disabled = false;
        }
      };
    
    
      /**
       * Shopify section event handler
       */
      HomepageHeroSlider.prototype.onSelect = function() {
        window.top.addEventListener('input', this.slideHandler.bind(this));
        window.top.addEventListener('change', this.slideHandler.bind(this));
      };
    
    
      /**
       * Shopify section event handler
       */
      HomepageHeroSlider.prototype.onDeselect = function() {
        window.top.removeEventListener('input', this.slideHandler.bind(this));
        window.top.removeEventListener('change', this.slideHandler.bind(this));
      };
    
    
      /**
       * Shopify section event handler
       */
      HomepageHeroSlider.prototype.onBlockSelect = function(event) {
        // Go to the currently selected block in slick carousel and pause
        var index = parseInt(event.target.dataset.slickIndex, 10);
        this.$slider.slick('slickGoTo', index).slick('slickPause');
      };
    
    
      /**
       * Shopify section event handler
       */
      HomepageHeroSlider.prototype.onBlockDeselect = function() {
        // Resume carousel
        this.$slider.slick('slickPlay');
      };
    
    
      return HomepageHeroSlider;
  })();
  window.theme.sections.register('homepage-hero-slider', theme.HomepageHeroSlider);
  window.theme._registeredSections['homepage-hero-slider'] = true;
}
  